import React, { Component } from 'react'
import { Flex } from 'hljd'
import { MEAL_TAG_IMG } from '@constant'
import style from './style.module.less'
import { observer, inject } from 'mobx-react'
import { CollectorsCount } from '../../Common/Goods'
import { isSiDaMember } from '@util'
import {
  getMealPriceColor,
  getMealTitleColor
} from '@components/LocalMerchant/Decoration/util'

@inject('decorationStore')
@observer
export default class extends Component {
  render() {
    const {
      list,
      decorationStore: { newThemeConfig, theme }
    } = this.props
    return (
      <Flex wrap className={style.list}>
        {list.map(item => {
          let {
            cover_path,
            title,
            show_price,
            hot_tag,
            coupon_info,
            new_tag
          } = item
          new_tag = new_tag || ''
          return (
            <Flex key={item.id} d="v" className={style.item}>
              <div className={style.cover}>
                <img
                  className={style.coverPath}
                  style={{ width: 167.5, height: 112 }}
                  src={cover_path}
                />

                {!isSiDaMember() && (
                  <img
                    className={style.hotTag}
                    src={MEAL_TAG_IMG[hot_tag + '']}
                  />
                )}
              </div>

              <Flex className={style.info} d="v" sp>
                <div>
                  <div
                    className={style.title}
                    style={{ color: getMealTitleColor(theme) }}
                  >
                    {title}
                  </div>

                  <div>
                    {coupon_info && (
                      <div
                        style={{
                          color: newThemeConfig['themeColor'],
                          border: `1px solid ${newThemeConfig['themeColor']}`
                        }}
                        className={style.tag}
                      >
                        {coupon_info}
                      </div>
                    )}

                    {new_tag
                      .split(',')
                      .filter(Boolean)
                      .map((item, index) => {
                        return (
                          <div
                            key={index}
                            className={style.tag}
                            style={{
                              color: newThemeConfig['themeColor'],
                              border: `1px solid ${
                                newThemeConfig['themeColor']
                              }`
                            }}
                          >
                            {item}
                          </div>
                        )
                      })}
                  </div>
                </div>

                <Flex sp className={style.bottom}>
                  <div style={{ color: getMealPriceColor(theme) }}>
                    <span className={style.unit}>¥</span>
                    <span className={style.price}>{show_price}</span>
                  </div>

                  <CollectorsCount {...item} />
                </Flex>
              </Flex>
            </Flex>
          )
        })}
      </Flex>
    )
  }
}
